import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dataSharingTokenStatus' })
export class DataSharingTokenStatusPipe implements PipeTransform {

    transform(value: any): any {
        const label = value ? 'ACCEPTED' : 'PENDING'
        const style = value ? "color: #3D7300;background-color: #7AE50026;" : "color: #212121;background-color: #42424226;";
        const iconColor = value ? "#7AE500" : "#424242"
        return `<div class="sm-status-badge" style="${style}">
                    <span class="material-symbols-outlined sm-status-badge-icon" style="color: ${iconColor}">square</span>     
                    ${label}
                </div>`;
    }

}